import { React, PropTypes, reduxConnect } from '../lib/imports';
import { Loader } from '../components';
import { useCdnImage, getAssetSet } from '../app/context/config';

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const Loading = ({ loadingText, isFixed }) => {
  return <Loader assetUrl={assetSet('loadingSticks')} text={loadingText} isFixed={isFixed} />;
};

const mapStateToProps = (state) => {
  const { strings } = state;

  return {
    loadingText: strings['global/loading/text'],
  };
};

Loading.propTypes = {
  loadingText: PropTypes.string,
  isFixed: PropTypes.bool,
};

export default reduxConnect(mapStateToProps)(Loading);
